import CommonLayout from "../../_utils/CommonLayout";

import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const ReimbursementRequestTxnConfirm = (props) => {
  // Callbacks
  return (
    <div className="max-w-tab-width-normal mx-auto w-width-full Qsmd:pt-padding-lg pt-padding-md Qlg:px-padding-base px-padding-md">
      <CommonLayout>
        <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />
        </div>

        <div className="lg:max-w-[var(--create-box-width)]  w-width-full">
          <Amount
            isPreview={true}
            txnPayLoad={props?.txnPayLoad}
          />
        </div>
        <div className="flex flex-col gap-gap-md">
          <CategorySelector
            previewMode={true}
            selectedCategory={props?.txnPayLoad?.selectedCategory}
            category={props?.txnPayLoad?.mergeCategory || []}
            IFSC={props?.txnPayLoad?.bankAccountIFSC}
            accountNumber={props?.txnPayLoad?.bankAccountNo}
            beneAccountId={props?.txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />
        </div>
        <div className="lg:max-w-[var(--create-box-width)] lg:w-width-full w-width-full mb-margin-lg">
          <AdditionalDetailsPreviewMapper
            mappingData={props.txnPayLoad.mergeCategory}
            previewImages={props?.previewImages}
          />
        </div>
      </CommonLayout>

      <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
    </div>
  );
};

export default ReimbursementRequestTxnConfirm;
